import React, { useMemo } from 'react'
import { Paper, Group, Box, Avatar, Text, Divider, Badge, Grid, Button, ActionIcon } from '@mantine/core'
import dayjs from 'dayjs'
import { IconArrowRight, IconPencil, IconPrinter, IconRefresh, IconTrash } from '@tabler/icons-react'
import { useNavigate } from 'react-router-dom'

const UserList = ({ actionMethod, data, params }) => {
  const navigate = useNavigate()
  const dataUsers = data

  const isDeleted = useMemo(() => {
    return !params['filter[deleted_at][null]']
  }, [params])

  const mappingListUser = (userData) => {

    const mappingIdentity = (identity) => {
      if (identity === '53') {
        return 'Need Approval'
      } else if (identity === '51') {
        return 'Verified'
      } else {
        return 'Unverified'
      }
    }

    const remapData = userData.map((val, index) => {
      return (
        <Paper shadow="sm" withBorder p="md" mb={12} key={index}>
          <Grid>
            <Grid.Col span={3} style={{ borderRight: '1px solid #b3bec9' }}>
              <Group gap='sm' align='center' mb={16}>
                <Avatar variant='filled' name={val.name} radius="xl" size="md" color='red' />
                <Box>
                  <Text fz={14}>{val.name}</Text>
                  <Text fz={12} c='gray.5'>{val.email !== null ? val.email : '-'}</Text>
                </Box>
              </Group>
              <Group align='center' grow>
                <Box>
                  <Text fz={14} c='gray.6'>ID Member</Text>
                  <Text fz={14}>{val.id}</Text>
                </Box>
                <Box>
                  <Text fz={14} c='gray.6'>Phone</Text>
                  <Text fz={14}>{val.phone ? val.phone : '-'}</Text>
                </Box>
              </Group>
            </Grid.Col>
            <Grid.Col span={3} ml={12} style={{ borderRight: '1px solid #b3bec9' }}>
              <Group gap='sm' mb={16}>
                <Box>
                  <Text fz={14} c='gray.6'>Verified Identity</Text>
                  <Group>
                    <Badge variant='light' color='gray.6' size='md' style={{ textTransform: 'capitalize', fontWeight: '500', fontSize: '12px' }}>{mappingIdentity(val.verifiedIdentity)}</Badge>
                    {
                      !isDeleted 
                      && <ActionIcon variant="subtle"  aria-label="Settings" onClick={() => navigate(`/users/${val.id}?tab=verification`)}>
                        <IconPencil style={{ width: '70%', height: '70%' }} stroke={1.5} />
                      </ActionIcon>
                    }
                  </Group>
                </Box>
              </Group>
              <Group align='center' grow>
                <Box>
                  <Text fz={14} c='gray.6'>Member Start Date</Text>
                  <Text fz={14}>{dayjs(val.memberStartDate).format('DD MMMM YYYY')}</Text>
                </Box>
                <Box>
                  <Text fz={14} c='gray.6'>Member Expired Date</Text>
                  <Text fz={14}>{dayjs(val.memberExpired).format('DD MMMM YYYY')}</Text>
                </Box>
              </Group>
            </Grid.Col>
            <Grid.Col span={5} ml={12}>
              <Group gap='sm' grow mb={16}>
                <Box>
                  <Text fz={14} c='gray.6'>Country Catalog</Text>
                  <Text fz={14}>
                    {val.countryCatalogsName.length > 0 ? val.countryCatalogsName.join(', ') : '-'}
                  </Text>
                </Box>
                <Box>
                  <Text fz={14} c='gray.6'>Country Signup</Text>
                  <Text fz={14}>{val.countrySignup ? val.countrySignup : '-'}</Text>
                </Box>
                <Box>
                  <Text fz={14} c='gray.6'>Referred By</Text>
                  <Text fz={14}>{val.referredBy ? val.referredBy : '-'}</Text>
                </Box>
              </Group>
              <Group gap='sm' grow>
                <Box>
                  <Text fz={14} c='gray.6'>Total Order</Text>
                  <Text fz={14}>{val.totalOrder}</Text>
                </Box>
                <Box>
                  <Text fz={14} c='gray.6'>Total Product</Text>
                  <Text fz={14}>{val.totalProducts}</Text>
                </Box>
                <Box>
                  <Text fz={14} c='gray.6'>Status</Text>
                  <Text fz={14}>{val.active ? 'Active' : 'Inactive'}</Text>
                </Box>
              </Group>
            </Grid.Col>
          </Grid>
          <Divider mt={14} />
          <Group justify="space-between" gap="xs" mt={'xs'}>
            <Group>
              {
                val.memberships.length !== 0 &&
                <Badge size='sm' variant="gradient" gradient={{ from: 'cyan', to: 'blue', deg: 131 }}>
                  {val.memberships[0]}
                </Badge>
              }
              <Text fz={14} c='gray.6'>Last Login: {val.lastLogin || '-'}</Text>
              <Text fz={14} c='gray.6'>Last Session: {val.lastSession || '-'}</Text>
            </Group>
            {
              isDeleted
              ? (
                <Group>
                  <Button leftSection={<IconRefresh size={14} />} variant="outline" size='xs' onClick={() => actionMethod(val, 'restore')}>Restore</Button>
                  <Button leftSection={<IconTrash size={14} />} variant="filled" size='xs' onClick={() => actionMethod(val, 'permanentDelete')}>Permanent Delete</Button>
                </Group>
              )
              : (
                <Group>
                  <Button leftSection={<IconTrash size={14} />} variant="outline" size='xs' onClick={() => actionMethod(val, 'delete')}>Delete</Button>
                  <Button leftSection={<IconPrinter size={14} />} variant="outline" size='xs' onClick={() => navigate(`/users/${val.id}?tab=balanceHistory`) }>Balance History</Button>
                  <Button size='xs' rightSection={<IconArrowRight size={14} />} onClick={() => navigate(`/users/${val.id}`) }>Detail</Button>
                </Group>
              )
            }
          </Group>
        </Paper>
      )
    })
    return remapData
  }
  return (
    <Box>
      {mappingListUser(dataUsers)}
    </Box>
  )
}

export default UserList